import { render, staticRenderFns } from "./HomeAccountData.vue?vue&type=template&id=2ef4ad40&scoped=true&"
import script from "./HomeAccountData.vue?vue&type=script&lang=js&"
export * from "./HomeAccountData.vue?vue&type=script&lang=js&"
import style0 from "./HomeAccountData.vue?vue&type=style&index=0&id=2ef4ad40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4ad40",
  null
  
)

export default component.exports